import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

function PageContainer(props) {
  return (
    <Flex flex='1 1 auto' flexDir='column' alignItems='center' justifyContent='center' w='100%'>
      {props.children}
    </Flex>
  );
}

PageContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.bool]))
  ]).isRequired
};

export default PageContainer;
